import { render, staticRenderFns } from "./IrrListComponent.vue?vue&type=template&id=da953542"
import script from "./IrrListComponent.vue?vue&type=script&lang=js"
export * from "./IrrListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports